import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6 text-orpi-secondary">Politique de Confidentialité</h1>
      
      <p className="mb-4">Dernière mise à jour : {new Date().toLocaleDateString()}</p>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">1. Introduction</h2>
          <p>
            La présente Politique de Confidentialité décrit comment ORPI France collecte, utilise et 
            protège vos données personnelles lors de votre utilisation de notre service de demande de 
            financement immobilier en ligne (ci-après le "Service").
          </p>
          <p className="mt-2">
            Nous nous engageons à respecter votre vie privée et à protéger les informations que vous nous 
            communiquez conformément au Règlement Général sur la Protection des Données (RGPD) et à la 
            législation française applicable en matière de protection des données personnelles.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">2. Responsable du traitement</h2>
          <p>
            ORPI France, Société Civile Coopérative à capital variable, dont le siège social est situé 
            [adresse complète], enregistrée au RCS de [ville] sous le numéro [numéro RCS], est responsable 
            du traitement de vos données personnelles.
          </p>
          <p className="mt-2">
            Pour toute question relative à la protection de vos données personnelles, vous pouvez contacter 
            notre Délégué à la Protection des Données (DPO) à l'adresse email suivante : contact@orpi.live.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">3. Données collectées</h2>
          <p>
            Dans le cadre de notre Service, nous collectons et traitons les catégories de données suivantes :
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Données d'identification : civilité, nom, prénom, date de naissance, lieu de naissance, nationalité</li>
            <li>Coordonnées : adresse postale, email, numéro de téléphone</li>
            <li>Situation familiale : statut marital, nombre de personnes à charge</li>
            <li>Informations professionnelles : profession, type de contrat, employeur, ancienneté, revenus</li>
            <li>Informations financières : revenus mensuels, charges, crédits en cours, épargne</li>
            <li>Informations bancaires : nom de la banque, ancienneté</li>
            <li>Documents justificatifs : pièce d'identité, justificatifs de revenus, relevés bancaires, avis d'imposition</li>
            <li>Données de connexion : adresse IP, type de navigateur, pages visitées</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">4. Finalités et bases légales du traitement</h2>
          <p>
            Nous traitons vos données personnelles pour les finalités suivantes :
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-3">
            <li>
              <strong>Étude et traitement de votre demande de financement</strong>
              <br />
              Base légale : Exécution de mesures précontractuelles ou d'un contrat auquel vous êtes partie
            </li>
            <li>
              <strong>Gestion de la relation client</strong>
              <br />
              Base légale : Exécution d'un contrat auquel vous êtes partie
            </li>
            <li>
              <strong>Respect de nos obligations légales et réglementaires</strong> (notamment en matière de lutte contre le blanchiment d'argent)
              <br />
              Base légale : Obligation légale
            </li>
            <li>
              <strong>Amélioration de nos services et analyse statistique</strong>
              <br />
              Base légale : Intérêt légitime
            </li>
            <li>
              <strong>Prospection commerciale</strong> (sous réserve de votre consentement pour les communications électroniques)
              <br />
              Base légale : Consentement ou intérêt légitime selon les canaux utilisés
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">5. Destinataires des données</h2>
          <p>
            Vos données personnelles peuvent être transmises aux catégories de destinataires suivantes :
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Notre personnel habilité en charge du traitement de votre dossier</li>
            <li>Nos sous-traitants techniques et prestataires de services qui agissent sur nos instructions</li>
            <li>Nos partenaires bancaires et organismes de crédit pour l'évaluation de votre dossier</li>
            <li>Les autorités administratives ou judiciaires lorsque la loi l'exige</li>
          </ul>
          <p className="mt-2">
            Nous veillons à ce que ces destinataires respectent la confidentialité de vos données et les 
            traitent conformément aux lois applicables en matière de protection des données.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">6. Durée de conservation</h2>
          <p>
            Nous conservons vos données personnelles uniquement pendant la durée nécessaire à la réalisation 
            des finalités pour lesquelles elles ont été collectées, conformément à notre politique de 
            conservation des données et aux obligations légales auxquelles nous sommes soumis.
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Données relatives aux clients : 5 ans à compter de la fin de la relation commerciale</li>
            <li>Données relatives aux prospects : 3 ans à compter du dernier contact</li>
            <li>Documents comptables et pièces justificatives : 10 ans</li>
            <li>Données de connexion : 13 mois maximum</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">7. Vos droits</h2>
          <p>
            Conformément à la réglementation applicable, vous disposez des droits suivants sur vos données personnelles :
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Droit d'accès : obtenir la confirmation que vos données sont traitées et en demander une copie</li>
            <li>Droit de rectification : faire corriger des données inexactes ou incomplètes</li>
            <li>Droit à l'effacement : demander la suppression de vos données dans certains cas</li>
            <li>Droit à la limitation du traitement : demander la restriction temporaire du traitement</li>
            <li>Droit à la portabilité : recevoir vos données dans un format structuré et les transmettre à un tiers</li>
            <li>Droit d'opposition : vous opposer au traitement de vos données, notamment à des fins de prospection</li>
            <li>Droit de retirer votre consentement à tout moment, lorsque le traitement est fondé sur le consentement</li>
            <li>Droit de définir des directives relatives au sort de vos données après votre décès</li>
          </ul>
          <p className="mt-2">
            Pour exercer ces droits, vous pouvez nous contacter par email à contact@orpi.live ou par courrier postal 
            à l'adresse suivante : ORPI France - Service DPO, [adresse postale].
          </p>
          <p className="mt-2">
            Vous disposez également du droit d'introduire une réclamation auprès de la Commission Nationale 
            de l'Informatique et des Libertés (CNIL) si vous estimez que le traitement de vos données personnelles 
            constitue une violation de la réglementation applicable.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">8. Sécurité des données</h2>
          <p>
            Nous mettons en œuvre des mesures techniques et organisationnelles appropriées afin de garantir 
            un niveau de sécurité adapté au risque et de protéger vos données personnelles contre toute 
            perte, destruction, altération ou accès non autorisé.
          </p>
          <p className="mt-2">
            Ces mesures incluent notamment :
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Le chiffrement des données sensibles</li>
            <li>Des procédures visant à tester et évaluer régulièrement l'efficacité des mesures de sécurité</li>
            <li>Des restrictions d'accès aux données personnelles</li>
            <li>La sensibilisation et la formation de notre personnel aux exigences de sécurité</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">9. Transferts de données hors UE</h2>
          <p>
            Nous nous efforçons de traiter vos données personnelles au sein de l'Union Européenne. Toutefois, 
            dans certains cas, vos données peuvent être transférées vers des pays situés en dehors de l'Union 
            Européenne.
          </p>
          <p className="mt-2">
            Dans ce cas, nous veillons à ce que ces transferts soient effectués vers des pays assurant un 
            niveau de protection adéquat ou qu'ils soient encadrés par des garanties appropriées conformément 
            à la réglementation applicable (clauses contractuelles types approuvées par la Commission 
            Européenne, règles d'entreprise contraignantes, etc.).
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">10. Cookies et technologies similaires</h2>
          <p>
            Notre site web utilise des cookies et des technologies similaires pour améliorer votre expérience 
            de navigation, analyser l'utilisation du site et personnaliser nos services.
          </p>
          <p className="mt-2">
            Pour en savoir plus sur notre utilisation des cookies et sur vos options en matière de 
            paramétrage, veuillez consulter notre <Link to="/cookies" className="text-orpi-primary hover:underline">Politique des Cookies</Link>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">11. Modification de la politique de confidentialité</h2>
          <p>
            Nous nous réservons le droit de modifier la présente politique de confidentialité à tout moment. 
            Toute modification sera publiée sur cette page avec une date de mise à jour actualisée.
          </p>
          <p className="mt-2">
            Nous vous encourageons à consulter régulièrement cette politique pour prendre connaissance de 
            toute modification. En cas de modification substantielle, nous vous en informerons par les moyens 
            que nous jugeons appropriés.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">12. Contact</h2>
          <p>
            Pour toute question concernant cette politique de confidentialité ou nos pratiques en matière 
            de protection des données, veuillez nous contacter :
          </p>
          <p className="mt-2">
            ORPI France<br />
            [Adresse]<br />
            Email : contact@orpi.live<br />
            Téléphone : [numéro de téléphone]
          </p>
        </section>
      </div>
      
      <div className="mt-10">
        <Link to="/" className="text-orpi-primary hover:underline">Retour à l'accueil</Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;